import createTheme from '@mui/material/styles/createTheme';

export const light = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#63084b',
    },
    secondary: {
      main: '#fa5224',
      contrastText: '#fff',
    },
    background: {
      default: '#fffff',
    },
  },
  shape: {
    borderRadius: 32,
  },
  typography: {
    fontFamily: 'Dosis',
    fontSize: 14,
    button: {
      textTransform: 'none',
    },
    subtitle1: {
      lineHeight: 1.2,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#fcfafb',
          opacity: 1,
          fontSize: '12px',
          color: 'black',
          border: '2px solid #fa5224',
          borderRadius: '16px',
        },
        arrow: {
          color: '#fa5224',
        },
      },
    },
  },
});

export const dark = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#1D1F20',
    },
    primary: {
      main: '#fff',
    },
    secondary: {
      main: '#EB5757',
    },
  },
});
